import { render, staticRenderFns } from "./IconWarn.vue?vue&type=template&id=a0468498&scoped=true&"
import script from "./IconWarn.vue?vue&type=script&lang=js&"
export * from "./IconWarn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0468498",
  null
  
)

export default component.exports